import id1 from './images/employees/Khushboo.webp';
import id2 from './images/employees/Nandu.webp';
import id3 from './images/employees/Inder.jfif.webp';
import id4 from './images/employees/Lakshay.webp';
import id5 from './images/employees/Maano.webp';
import id6 from './images/employees/Mandeep.webp';
import id7 from './images/employees/Vigas.webp';
import id8 from './images/employees/Gaurav.webp';
import id9 from './images/employees/Sahib.webp';
import id10 from './images/employees/Varmillion.webp';
import id11 from './images/employees/Arsh.webp';
import id12 from './images/employees/Harminder.webp';
import id13 from './images/employees/Divyanshu.webp';
import id14 from './images/employees/Rajvir.webp';
import id15 from './images/employees/Shiv-Charan.webp';
import id16 from './images/employees/Amanjot.webp';
import id17 from './images/employees/Gurjit.webp';
import id18 from './images/employees/Shaina.webp';
import id19 from './images/employees/Ghost.webp';
import id20 from './images/employees/Palak.webp';
import id21 from './images/employees/Kamal.webp';
import id22 from './images/employees/Harry.webp';
import id23 from './images/employees/Anmol.webp';
import id24 from './images/employees/Dheeraj.webp';
import id25 from './images/employees/Jaspreet.webp';
import id26 from './images/employees/Khushi.webp';
import id27 from './images/employees/Uttamdeep.webp';
import id28 from './images/employees/Sanchit.webp';
import id0 from './images/employees/pl-2.webp';

import {
  ForbyIcon, MollyIcon, SkillshapeIcon, ITBIIcon, FlamencosIcon, NuieeIcon, CwhqIcon, KomenIcon,
} from './icons/project';

import CWHQ_VIDEO from './videos/projects/cwhq.mp4';

import MAZZOLARI_TITLE from './images/projects/mazzolari/title.webp';
import MAZZOLARI_STACK_1 from './images/projects/mazzolari/stack_1.webp';
import MAZZOLARI_STACK_2 from './images/projects/mazzolari/stack_2.webp';
import MAZZOLARI_STACK_3 from './images/projects/mazzolari/stack_3.webp';
import MAZZOLARI_STACK_4 from './images/projects/mazzolari/stack_4.webp';
import MAZZOLARI_STACK_5 from './images/projects/mazzolari/stack_5.webp';
import MAZZOLARI_SLIDER_1 from './images/projects/mazzolari/slider_1.webp';
import MAZZOLARI_SLIDER_2 from './images/projects/mazzolari/slider_2.webp';
import MAZZOLARI_SLIDER_3 from './images/projects/mazzolari/slider_3.webp';
import MAZZOLARI_SLIDER_4 from './images/projects/mazzolari/slider_4.webp';
import MAZZOLARI_SLIDER_5 from './images/projects/mazzolari/slider_5.webp';

import PICBELLY_TITLE from './images/projects/picbelly/title.webp';
import PICBELLY_STACK_1 from './images/projects/picbelly/stack_1.webp';
import PICBELLY_STACK_2 from './images/projects/picbelly/stack_2.webp';
import PICBELLY_STACK_3 from './images/projects/picbelly/stack_3.webp';
import PICBELLY_STACK_4 from './images/projects/picbelly/stack_4.webp';
import PICBELLY_STACK_5 from './images/projects/picbelly/stack_5.webp';
import PICBELLY_STACK_6 from './images/projects/picbelly/stack_6.webp';

import CWHQ_TITLE from './images/projects/cwhq/title.webp';
import CWHQ_STACK_1 from './images/projects/cwhq/stack_1.webp';
import CWHQ_STACK_2 from './images/projects/cwhq/stack_2.webp';
import CWHQ_STACK_3 from './images/projects/cwhq/stack_3.webp';
import CWHQ_STACK_4 from './images/projects/cwhq/stack_4.webp';
import CWHQ_STACK_5 from './images/projects/cwhq/stack_5.webp';
import CWHQ_STACK_6 from './images/projects/cwhq/stack_6.webp';

import KOMEN_TITLE from './images/projects/komen/title.webp';
import KOMEN_STACK_1 from './images/projects/komen/stack_1.webp';
import KOMEN_STACK_2 from './images/projects/komen/stack_2.webp';
import KOMEN_STACK_3 from './images/projects/komen/stack_3.webp';
import KOMEN_STACK_4 from './images/projects/komen/stack_4.webp';
import KOMEN_STACK_5 from './images/projects/komen/stack_5.webp';
import KOMEN_STACK_6 from './images/projects/komen/stack_6.webp';
import KOMEN_SLIDER_1 from './images/projects/komen/slider_1.webp';
import KOMEN_SLIDER_2 from './images/projects/komen/slider_2.webp';
import KOMEN_SLIDER_3 from './images/projects/komen/slider_3.webp';
import KOMEN_SLIDER_4 from './images/projects/komen/slider_4.webp';

import NIUEE_TITLE from './images/projects/niuee/title.webp';
import NIUEE_STACK_1 from './images/projects/niuee/stack_1.webp';
import NIUEE_STACK_2 from './images/projects/niuee/stack_2.webp';
import NIUEE_STACK_3 from './images/projects/niuee/stack_3.webp';
import NIUEE_STACK_4 from './images/projects/niuee/stack_4.webp';
import NIUEE_STACK_5 from './images/projects/niuee/stack_5.webp';
import NIUEE_STACK_6 from './images/projects/niuee/stack_6.webp';
import NIUEE_STACK_7 from './images/projects/niuee/stack_7.webp';
import NIUEE_SLIDER_1 from './images/projects/niuee/slider_1.webp';
import NIUEE_SLIDER_2 from './images/projects/niuee/slider_2.webp';
import NIUEE_SLIDER_3 from './images/projects/niuee/slider_3.webp';
import NIUEE_SLIDER_4 from './images/projects/niuee/slider_4.webp';
import NIUEE_SLIDER_5 from './images/projects/niuee/slider_5.webp';
import NIUEE_SLIDER_6 from './images/projects/niuee/slider_6.webp';
import NIUEE_SLIDER_7 from './images/projects/niuee/slider_7.webp';
import NIUEE_SLIDER_8 from './images/projects/niuee/slider_8.webp';

import MOLLY_TITLE from './images/projects/molly/title.webp';
import MOLLY_STACK_1 from './images/projects/molly/stack_1.webp';
import MOLLY_STACK_2 from './images/projects/molly/stack_2.webp';
import MOLLY_STACK_3 from './images/projects/molly/stack_3.webp';
import MOLLY_STACK_4 from './images/projects/molly/stack_4.webp';
import MOLLY_STACK_5 from './images/projects/molly/stack_5.webp';
import MOLLY_STACK_6 from './images/projects/molly/stack_6.webp';

import SKILLSHAPE_TITLE from './images/projects/skillshape/title.webp';
import SKILLSHAPE_STACK_1 from './images/projects/skillshape/stack_1.webp';
import SKILLSHAPE_STACK_2 from './images/projects/skillshape/stack_2.webp';
import SKILLSHAPE_STACK_3 from './images/projects/skillshape/stack_3.webp';
import SKILLSHAPE_STACK_4 from './images/projects/skillshape/stack_4.webp';
import SKILLSHAPE_STACK_5 from './images/projects/skillshape/stack_5.webp';
import SKILLSHAPE_STACK_6 from './images/projects/skillshape/stack_6.webp';
import SKILLSHAPE_STACK_7 from './images/projects/skillshape/stack_7.webp';
import SKILLSHAPE_SLIDER_1 from './images/projects/skillshape/slider_1.webp';
import SKILLSHAPE_SLIDER_2 from './images/projects/skillshape/slider_2.webp';
import SKILLSHAPE_SLIDER_3 from './images/projects/skillshape/slider_3.webp';
import SKILLSHAPE_SLIDER_4 from './images/projects/skillshape/slider_4.webp';
import SKILLSHAPE_SLIDER_5 from './images/projects/skillshape/slider_5.webp';

import FLAMENCOS_TITLE from './images/projects/flamencos-online/title.webp';
import FLAMENCOS_STACK_1 from './images/projects/flamencos-online/stack_1.webp';
import FLAMENCOS_STACK_2 from './images/projects/flamencos-online/stack_2.webp';
import FLAMENCOS_STACK_3 from './images/projects/flamencos-online/stack_3.webp';
import FLAMENCOS_STACK_4 from './images/projects/flamencos-online/stack_4.webp';
import FLAMENCOS_STACK_5 from './images/projects/flamencos-online/stack_5.webp';
import FLAMENCOS_SLIDER_1 from './images/projects/flamencos-online/slider_1.webp';
import FLAMENCOS_SLIDER_2 from './images/projects/flamencos-online/slider_2.webp';
import FLAMENCOS_SLIDER_3 from './images/projects/flamencos-online/slider_3.webp';
import FLAMENCOS_SLIDER_4 from './images/projects/flamencos-online/slider_4.webp';
import FLAMENCOS_SLIDER_5 from './images/projects/flamencos-online/slider_5.webp';
import FLAMENCOS_SLIDER_6 from './images/projects/flamencos-online/slider_6.webp';
import FLAMENCOS_SLIDER_7 from './images/projects/flamencos-online/slider_7.webp';
import FLAMENCOS_SLIDER_8 from './images/projects/flamencos-online/slider_8.webp';
import FLAMENCOS_SLIDER_9 from './images/projects/flamencos-online/slider_9.webp';
import FLAMENCOS_SLIDER_10 from './images/projects/flamencos-online/slider_10.webp';
import FLAMENCOS_SLIDER_11 from './images/projects/flamencos-online/slider_11.webp';
import FLAMENCOS_SLIDER_12 from './images/projects/flamencos-online/slider_12.webp';

import ITBI_TITLE from './images/projects/itbi/title.webp';
import ITBI_STACK_1 from './images/projects/itbi/stack_1.webp';
import ITBI_STACK_2 from './images/projects/itbi/stack_2.webp';
import ITBI_STACK_3 from './images/projects/itbi/stack_3.webp';
import ITBI_STACK_4 from './images/projects/itbi/stack_4.webp';
import ITBI_STACK_5 from './images/projects/itbi/stack_5.webp';
import ITBI_SLIDER_1 from './images/projects/itbi/slider_1.webp';
import ITBI_SLIDER_2 from './images/projects/itbi/slider_2.webp';
import ITBI_SLIDER_3 from './images/projects/itbi/slider_3.webp';
import ITBI_SLIDER_4 from './images/projects/itbi/slider_4.webp';
import ITBI_SLIDER_5 from './images/projects/itbi/slider_5.webp';

// import FORBY_TITLE from './images/projects/forby/title.png';
// import FORBY_STACK_1 from './images/projects/forby/stack_1.png';
// import FORBY_STACK_2 from './images/projects/forby/stack_2.png';
// import FORBY_STACK_3 from './images/projects/forby/stack_3.png';
import FORBY_STACK_4 from './images/projects/forby/stack_4.png';
// import FORBY_STACK_5 from './images/projects/forby/stack_5.png';
// import FORBY_SLIDER_1 from './images/projects/forby/slider_1.png';
// import FORBY_SLIDER_2 from './images/projects/forby/slider_2.png';
// import FORBY_SLIDER_3 from './images/projects/forby/slider_3.png';
// import FORBY_SLIDER_4 from './images/projects/forby/slider_4.png';
// import FORBY_SLIDER_5 from './images/projects/forby/slider_5.png';
// import FORBY_SLIDER_6 from './images/projects/forby/slider_6.png';
// import FORBY_SLIDER_7 from './images/projects/forby/slider_7.png';
// import FORBY_SLIDER_8 from './images/projects/forby/slider_8.png';
// import FORBY_SLIDER_9 from './images/projects/forby/slider_9.png';
// import FORBY_SLIDER_10 from './images/projects/forby/slider_10.png';
// import FORBY_SLIDER_11 from './images/projects/forby/slider_11.png';
// import FORBY_SLIDER_12 from './images/projects/forby/slider_12.png';
// import FORBY_SLIDER_13 from './images/projects/forby/slider_13.png';
// import FORBY_SLIDER_14 from './images/projects/forby/slider_14.png';

// import PUERTO_RICO_TITLE from './images/projects/puerto-rico/title.png';
// import PUERTO_RICO_STACK_1 from './images/projects/puerto-rico/stack_1.png';
// import PUERTO_RICO_STACK_2 from './images/projects/puerto-rico/stack_2.png';
// import PUERTO_RICO_STACK_3 from './images/projects/puerto-rico/stack_3.png';
// import PUERTO_RICO_STACK_4 from './images/projects/puerto-rico/stack_4.png';
// import PUERTO_RICO_STACK_5 from './images/projects/puerto-rico/stack_5.png';
// import PUERTO_RICO_SLIDER_1 from './images/projects/puerto-rico/slider_1.png';
// import PUERTO_RICO_SLIDER_2 from './images/projects/puerto-rico/slider_2.png';
// import PUERTO_RICO_SLIDER_3 from './images/projects/puerto-rico/slider_3.png';
// import PUERTO_RICO_SLIDER_4 from './images/projects/puerto-rico/slider_4.png';
// import PUERTO_RICO_SLIDER_5 from './images/projects/puerto-rico/slider_5.png';
// import PUERTO_RICO_SLIDER_6 from './images/projects/puerto-rico/slider_6.png';
// import PUERTO_RICO_SLIDER_7 from './images/projects/puerto-rico/slider_7.png';
// import PUERTO_RICO_SLIDER_8 from './images/projects/puerto-rico/slider_8.png';
// import PUERTO_RICO_SLIDER_9 from './images/projects/puerto-rico/slider_9.png';
// import PUERTO_RICO_SLIDER_10 from './images/projects/puerto-rico/slider_10.png';
// import PUERTO_RICO_SLIDER_11 from './images/projects/puerto-rico/slider_11.png';
// import PUERTO_RICO_SLIDER_12 from './images/projects/puerto-rico/slider_12.png';

// import PUERTO_RICO_GUIDE_TITLE from './images/projects/puerto-rico-guide/title.png';
// import PUERTO_RICO_GUIDE_STACK_1 from './images/projects/puerto-rico-guide/stack_1.png';
// import PUERTO_RICO_GUIDE_STACK_2 from './images/projects/puerto-rico-guide/stack_2.png';
// import PUERTO_RICO_GUIDE_STACK_3 from './images/projects/puerto-rico-guide/stack_3.png';
// import PUERTO_RICO_GUIDE_STACK_4 from './images/projects/puerto-rico-guide/stack_4.png';
// import PUERTO_RICO_GUIDE_STACK_5 from './images/projects/puerto-rico-guide/stack_5.png';
// import PUERTO_RICO_GUIDE_STACK_6 from './images/projects/puerto-rico-guide/stack_6.png';
// import PUERTO_RICO_GUIDE_STACK_7 from './images/projects/puerto-rico-guide/stack_7.png';
// import PUERTO_RICO_GUIDE_STACK_8 from './images/projects/puerto-rico-guide/stack_8.png';
// import PUERTO_RICO_GUIDE_SLIDER_1 from './images/projects/puerto-rico-guide/slider_1.png';
// import PUERTO_RICO_GUIDE_SLIDER_2 from './images/projects/puerto-rico-guide/slider_2.png';
// import PUERTO_RICO_GUIDE_SLIDER_3 from './images/projects/puerto-rico-guide/slider_3.png';
// import PUERTO_RICO_GUIDE_SLIDER_4 from './images/projects/puerto-rico-guide/slider_4.png';
// import PUERTO_RICO_GUIDE_SLIDER_5 from './images/projects/puerto-rico-guide/slider_5.png';
// import PUERTO_RICO_GUIDE_SLIDER_6 from './images/projects/puerto-rico-guide/slider_6.png';
// import PUERTO_RICO_GUIDE_SLIDER_7 from './images/projects/puerto-rico-guide/slider_7.png';

import WE_PATH_TITLE from './images/projects/we-path/title.webp';
import WE_PATH_STACK_1 from './images/projects/we-path/stack_1.webp';
import WE_PATH_STACK_2 from './images/projects/we-path/stack_2.webp';
import WE_PATH_STACK_3 from './images/projects/we-path/stack_3.webp';
import WE_PATH_STACK_4 from './images/projects/we-path/stack_4.webp';
import WE_PATH_STACK_5 from './images/projects/we-path/stack_5.webp';
import WE_PATH_STACK_6 from './images/projects/we-path/stack_6.webp';

// import AC_NAUTICA_TITLE from './images/projects/ac-nautica/title.png';
// import AC_NAUTICA_STACK_1 from './images/projects/ac-nautica/stack_1.png';
// import AC_NAUTICA_STACK_2 from './images/projects/ac-nautica/stack_2.png';
// import AC_NAUTICA_STACK_3 from './images/projects/ac-nautica/stack_3.png';
// import AC_NAUTICA_STACK_4 from './images/projects/ac-nautica/stack_4.png';
// import AC_NAUTICA_STACK_5 from './images/projects/ac-nautica/stack_5.png';
// import AC_NAUTICA_SLIDER_1 from './images/projects/ac-nautica/slider_1.png';
// import AC_NAUTICA_SLIDER_2 from './images/projects/ac-nautica/slider_2.png';
// import AC_NAUTICA_SLIDER_3 from './images/projects/ac-nautica/slider_3.png';
// import AC_NAUTICA_SLIDER_4 from './images/projects/ac-nautica/slider_4.png';
// import AC_NAUTICA_SLIDER_5 from './images/projects/ac-nautica/slider_5.png';
// import AC_NAUTICA_SLIDER_6 from './images/projects/ac-nautica/slider_6.png';

// import ALIBALANCE_TITLE from './images/projects/alibalance/alibalance_title.png';
// import ALIBALANCE_STACK_1 from './images/projects/alibalance/alibalance_stack_1.png';
// import ALIBALANCE_STACK_2 from './images/projects/alibalance/alibalance_stack_2.png';
// import ALIBALANCE_STACK_3 from './images/projects/alibalance/alibalance_stack_3.png';
// import ALIBALANCE_STACK_4 from './images/projects/alibalance/alibalance_stack_4.png';
// import ALIBALANCE_STACK_5 from './images/projects/alibalance/alibalance_stack_5.png';

// import GREEN_CLINIC_TITLE from './images/projects/green-clinic/title.png';
// import GREEN_CLINIC_STACK_1 from './images/projects/green-clinic/stack_1.png';
// import GREEN_CLINIC_STACK_2 from './images/projects/green-clinic/stack_2.png';
// import GREEN_CLINIC_STACK_3 from './images/projects/green-clinic/stack_3.png';
// import GREEN_CLINIC_STACK_4 from './images/projects/green-clinic/stack_4.png';
// import GREEN_CLINIC_SLIDER_1 from './images/projects/green-clinic/slider_1.png';
// import GREEN_CLINIC_SLIDER_2 from './images/projects/green-clinic/slider_2.png';
// import GREEN_CLINIC_SLIDER_3 from './images/projects/green-clinic/slider_3.png';
// import GREEN_CLINIC_SLIDER_4 from './images/projects/green-clinic/slider_4.png';
// import GREEN_CLINIC_SLIDER_5 from './images/projects/green-clinic/slider_5.png';
// import GREEN_CLINIC_SLIDER_6 from './images/projects/green-clinic/slider_6.png';
// import GREEN_CLINIC_SLIDER_7 from './images/projects/green-clinic/slider_7.png';
// import GREEN_CLINIC_SLIDER_8 from './images/projects/green-clinic/slider_8.png';
// import GREEN_CLINIC_SLIDER_9 from './images/projects/green-clinic/slider_9.png';

// import STTM_DESKTOP_TITLE from './images/projects/sttm-desktop/title.png';
// import STTM_DESKTOP_STACK_1 from './images/projects/sttm-desktop/stack_1.png';
// import STTM_DESKTOP_STACK_2 from './images/projects/sttm-desktop/stack_2.png';
// import STTM_DESKTOP_STACK_3 from './images/projects/sttm-desktop/stack_3.png';
// import STTM_DESKTOP_STACK_4 from './images/projects/sttm-desktop/stack_4.png';
// import STTM_DESKTOP_STACK_5 from './images/projects/sttm-desktop/stack_5.png';

// import DEMOBUTLER_TITLE from './images/projects/demobutler/title.png';
// import DEMOBUTLER_STACK_1 from './images/projects/demobutler/stack_1.png';
// import DEMOBUTLER_STACK_2 from './images/projects/demobutler/stack_2.png';
// import DEMOBUTLER_STACK_3 from './images/projects/demobutler/stack_3.png';
// import DEMOBUTLER_STACK_4 from './images/projects/demobutler/stack_4.png';
// import DEMOBUTLER_STACK_5 from './images/projects/demobutler/stack_5.png';
// import DEMOBUTLER_STACK_6 from './images/projects/demobutler/stack_6.png';
// import DEMOBUTLER_STACK_7 from './images/projects/demobutler/stack_7.png';
// import DEMOBUTLER_STACK_8 from './images/projects/demobutler/stack_8.png';
// import DEMOBUTLER_STACK_9 from './images/projects/demobutler/stack_9.png';
// import DEMOBUTLER_STACK_10 from './images/projects/demobutler/stack_10.png';
// import DEMOBUTLER_STACK_11 from './images/projects/demobutler/stack_11.png';
// import DEMOBUTLER_STACK_12 from './images/projects/demobutler/stack_12.png';
// import DEMOBUTLER_STACK_13 from './images/projects/demobutler/stack_13.png';
// import DEMOBUTLER_STACK_14 from './images/projects/demobutler/stack_14.png';
// import DEMOBUTLER_STACK_15 from './images/projects/demobutler/stack_15.png';
// import DEMOBUTLER_STACK_16 from './images/projects/demobutler/stack_16.jpg';

// import MERIT_TITLE from './images/projects/merit/title.png';
// import MERIT_STACK_1 from './images/projects/merit/stack_1.png';
// import MERIT_STACK_2 from './images/projects/merit/stack_2.png';
// import MERIT_STACK_3 from './images/projects/merit/stack_3.png';
// import MERIT_STACK_4 from './images/projects/merit/stack_4.png';
// import MERIT_STACK_5 from './images/projects/merit/stack_5.png';
// import MERIT_STACK_6 from './images/projects/merit/stack_6.png';

// import SELF_ID_TITLE from './images/projects/self-id/title.jpg';
// import SELF_ID_STACK_1 from './images/projects/self-id/stack_1.jpg';
// import SELF_ID_STACK_2 from './images/projects/self-id/stack_2.jpg';
// import SELF_ID_STACK_3 from './images/projects/self-id/stack_3.jpg';
// import SELF_ID_STACK_4 from './images/projects/self-id/stack_4.jpg';
// import SELF_ID_STACK_5 from './images/projects/self-id/stack_5.jpg';
// import SELF_ID_STACK_6 from './images/projects/self-id/stack_6.jpg';
// import SELF_ID_STACK_7 from './images/projects/self-id/stack_7.jpg';

export const employeeImageMapper = (employeeId) => {
  switch (employeeId) {
    case 1:
      return id1;
    case 2:
      return id2;
    case 3:
      return id3;
    case 4:
      return id4;
    case 5:
      return id5;
    case 6:
      return id6;
    case 7:
      return id7;
    case 8:
      return id8;
    case 9:
      return id9;
    case 10:
      return id10;
    case 11:
      return id11;
    case 12:
      return id12;
    case 13:
      return id13;
    case 14:
      return id14;
    case 15:
      return id15;
    case 16:
      return id16;
    case 17:
      return id17;
    case 18:
      return id18;
    case 19:
      return id19;
    case 20:
      return id20;
    case 21:
      return id21;
    case 22:
      return id22;
    case 23:
      return id23;
    case 24:
      return id24;
    case 25:
      return id25;
    case 26:
      return id26;
    case 27:
      return id27;
    case 28:
      return id28;
    default:
      return id0;
  }
};

export const projectLogoMapper = (projectId) => {
  switch (projectId) {
    case '01':
      return CwhqIcon;
    case '02':
      return SkillshapeIcon;
    case '03':
      return FlamencosIcon;
    case '04':
      return NuieeIcon;
    case '05':
      return KomenIcon;
    case '08':
      return MollyIcon;
    case '10':
      return ITBIIcon;
    default:
      return '';
  }
};

export const projectVideoMapper = (videoName) => {
  switch (videoName) {
    case 'CWHQ_VIDEO':
      return CWHQ_VIDEO;
    default:
      return '';
  }
};

export const projectImageMapper = (imageName) => {
  switch (imageName) {
    case 'MAZZOLARI_TITLE':
      return MAZZOLARI_TITLE;
    case 'MAZZOLARI_STACK_1':
      return MAZZOLARI_STACK_1;
    case 'MAZZOLARI_STACK_2':
      return MAZZOLARI_STACK_2;
    case 'MAZZOLARI_STACK_3':
      return MAZZOLARI_STACK_3;
    case 'MAZZOLARI_STACK_4':
      return MAZZOLARI_STACK_4;
    case 'MAZZOLARI_STACK_5':
      return MAZZOLARI_STACK_5;
    case 'MAZZOLARI_SLIDER_1':
      return MAZZOLARI_SLIDER_1;
    case 'MAZZOLARI_SLIDER_2':
      return MAZZOLARI_SLIDER_2;
    case 'MAZZOLARI_SLIDER_3':
      return MAZZOLARI_SLIDER_3;
    case 'MAZZOLARI_SLIDER_4':
      return MAZZOLARI_SLIDER_4;
    case 'MAZZOLARI_SLIDER_5':
      return MAZZOLARI_SLIDER_5;

    case 'PICBELLY_TITLE':
      return PICBELLY_TITLE;
    case 'PICBELLY_STACK_1':
      return PICBELLY_STACK_1;
    case 'PICBELLY_STACK_2':
      return PICBELLY_STACK_2;
    case 'PICBELLY_STACK_3':
      return PICBELLY_STACK_3;
    case 'PICBELLY_STACK_4':
      return PICBELLY_STACK_4;
    case 'PICBELLY_STACK_5':
      return PICBELLY_STACK_5;
    case 'PICBELLY_STACK_6':
      return PICBELLY_STACK_6;

    case 'CWHQ_TITLE':
      return CWHQ_TITLE;
    case 'CWHQ_STACK_1':
      return CWHQ_STACK_1;
    case 'CWHQ_STACK_2':
      return CWHQ_STACK_2;
    case 'CWHQ_STACK_3':
      return CWHQ_STACK_3;
    case 'CWHQ_STACK_4':
      return CWHQ_STACK_4;
    case 'CWHQ_STACK_5':
      return CWHQ_STACK_5;
    case 'CWHQ_STACK_6':
      return CWHQ_STACK_6;

    case 'KOMEN_TITLE':
      return KOMEN_TITLE;
    case 'KOMEN_STACK_1':
      return KOMEN_STACK_1;
    case 'KOMEN_STACK_2':
      return KOMEN_STACK_2;
    case 'KOMEN_STACK_3':
      return KOMEN_STACK_3;
    case 'KOMEN_STACK_4':
      return KOMEN_STACK_4;
    case 'KOMEN_STACK_5':
      return KOMEN_STACK_5;
    case 'KOMEN_STACK_6':
      return KOMEN_STACK_6;
    case 'KOMEN_SLIDER_1':
      return KOMEN_SLIDER_1;
    case 'KOMEN_SLIDER_2':
      return KOMEN_SLIDER_2;
    case 'KOMEN_SLIDER_3':
      return KOMEN_SLIDER_3;
    case 'KOMEN_SLIDER_4':
      return KOMEN_SLIDER_4;

    case 'NIUEE_TITLE':
      return NIUEE_TITLE;
    case 'NIUEE_STACK_1':
      return NIUEE_STACK_1;
    case 'NIUEE_STACK_2':
      return NIUEE_STACK_2;
    case 'NIUEE_STACK_3':
      return NIUEE_STACK_3;
    case 'NIUEE_STACK_4':
      return NIUEE_STACK_4;
    case 'NIUEE_STACK_5':
      return NIUEE_STACK_5;
    case 'NIUEE_STACK_6':
      return NIUEE_STACK_6;
    case 'NIUEE_STACK_7':
      return NIUEE_STACK_7;
    case 'NIUEE_SLIDER_1':
      return NIUEE_SLIDER_1;
    case 'NIUEE_SLIDER_2':
      return NIUEE_SLIDER_2;
    case 'NIUEE_SLIDER_3':
      return NIUEE_SLIDER_3;
    case 'NIUEE_SLIDER_4':
      return NIUEE_SLIDER_4;
    case 'NIUEE_SLIDER_5':
      return NIUEE_SLIDER_5;
    case 'NIUEE_SLIDER_6':
      return NIUEE_SLIDER_6;
    case 'NIUEE_SLIDER_7':
      return NIUEE_SLIDER_7;
    case 'NIUEE_SLIDER_8':
      return NIUEE_SLIDER_8;

    case 'MOLLY_TITLE':
      return MOLLY_TITLE;
    case 'MOLLY_STACK_1':
      return MOLLY_STACK_1;
    case 'MOLLY_STACK_2':
      return MOLLY_STACK_2;
    case 'MOLLY_STACK_3':
      return MOLLY_STACK_3;
    case 'MOLLY_STACK_4':
      return MOLLY_STACK_4;
    case 'MOLLY_STACK_5':
      return MOLLY_STACK_5;
    case 'MOLLY_STACK_6':
      return MOLLY_STACK_6;

    case 'SKILLSHAPE_TITLE':
      return SKILLSHAPE_TITLE;
    case 'SKILLSHAPE_STACK_1':
      return SKILLSHAPE_STACK_1;
    case 'SKILLSHAPE_STACK_2':
      return SKILLSHAPE_STACK_2;
    case 'SKILLSHAPE_STACK_3':
      return SKILLSHAPE_STACK_3;
    case 'SKILLSHAPE_STACK_4':
      return SKILLSHAPE_STACK_4;
    case 'SKILLSHAPE_STACK_5':
      return SKILLSHAPE_STACK_5;
    case 'SKILLSHAPE_STACK_6':
      return SKILLSHAPE_STACK_6;
    case 'SKILLSHAPE_STACK_7':
      return SKILLSHAPE_STACK_7;
    case 'SKILLSHAPE_SLIDER_1':
      return SKILLSHAPE_SLIDER_1;
    case 'SKILLSHAPE_SLIDER_2':
      return SKILLSHAPE_SLIDER_2;
    case 'SKILLSHAPE_SLIDER_3':
      return SKILLSHAPE_SLIDER_3;
    case 'SKILLSHAPE_SLIDER_4':
      return SKILLSHAPE_SLIDER_4;
    case 'SKILLSHAPE_SLIDER_5':
      return SKILLSHAPE_SLIDER_5;

    case 'FLAMENCOS_TITLE':
      return FLAMENCOS_TITLE;
    case 'FLAMENCOS_STACK_1':
      return FLAMENCOS_STACK_1;
    case 'FLAMENCOS_STACK_2':
      return FLAMENCOS_STACK_2;
    case 'FLAMENCOS_STACK_3':
      return FLAMENCOS_STACK_3;
    case 'FLAMENCOS_STACK_4':
      return FLAMENCOS_STACK_4;
    case 'FLAMENCOS_STACK_5':
      return FLAMENCOS_STACK_5;
    case 'FLAMENCOS_SLIDER_1':
      return FLAMENCOS_SLIDER_1;
    case 'FLAMENCOS_SLIDER_2':
      return FLAMENCOS_SLIDER_2;
    case 'FLAMENCOS_SLIDER_3':
      return FLAMENCOS_SLIDER_3;
    case 'FLAMENCOS_SLIDER_4':
      return FLAMENCOS_SLIDER_4;
    case 'FLAMENCOS_SLIDER_5':
      return FLAMENCOS_SLIDER_5;
    case 'FLAMENCOS_SLIDER_6':
      return FLAMENCOS_SLIDER_6;
    case 'FLAMENCOS_SLIDER_7':
      return FLAMENCOS_SLIDER_7;
    case 'FLAMENCOS_SLIDER_8':
      return FLAMENCOS_SLIDER_8;
    case 'FLAMENCOS_SLIDER_9':
      return FLAMENCOS_SLIDER_9;
    case 'FLAMENCOS_SLIDER_10':
      return FLAMENCOS_SLIDER_10;
    case 'FLAMENCOS_SLIDER_11':
      return FLAMENCOS_SLIDER_11;
    case 'FLAMENCOS_SLIDER_12':
      return FLAMENCOS_SLIDER_12;

    case 'ITBI_TITLE':
      return ITBI_TITLE;
    case 'ITBI_STACK_1':
      return ITBI_STACK_1;
    case 'ITBI_STACK_2':
      return ITBI_STACK_2;
    case 'ITBI_STACK_3':
      return ITBI_STACK_3;
    case 'ITBI_STACK_4':
      return ITBI_STACK_4;
    case 'ITBI_STACK_5':
      return ITBI_STACK_5;
    case 'ITBI_SLIDER_1':
      return ITBI_SLIDER_1;
    case 'ITBI_SLIDER_2':
      return ITBI_SLIDER_2;
    case 'ITBI_SLIDER_3':
      return ITBI_SLIDER_3;
    case 'ITBI_SLIDER_4':
      return ITBI_SLIDER_4;
    case 'ITBI_SLIDER_5':
      return ITBI_SLIDER_5;

      // case 'FORBY_TITLE':
      //   return FORBY_TITLE;
      // case 'FORBY_STACK_1':
      //   return FORBY_STACK_1;
      // case 'FORBY_STACK_2':
      //   return FORBY_STACK_2;
      // case 'FORBY_STACK_3':
      //   return FORBY_STACK_3;
      // case 'FORBY_STACK_4':
      //   return FORBY_STACK_4;
      // case 'FORBY_STACK_5':
      //   return FORBY_STACK_5;
      // case 'FORBY_SLIDER_1':
      //   return FORBY_SLIDER_1;
      // case 'FORBY_SLIDER_2':
      //   return FORBY_SLIDER_2;
      // case 'FORBY_SLIDER_3':
      //   return FORBY_SLIDER_3;
      // case 'FORBY_SLIDER_4':
      //   return FORBY_SLIDER_4;
      // case 'FORBY_SLIDER_5':
      //   return FORBY_SLIDER_5;
      // case 'FORBY_SLIDER_6':
      //   return FORBY_SLIDER_6;
      // case 'FORBY_SLIDER_7':
      //   return FORBY_SLIDER_7;
      // case 'FORBY_SLIDER_8':
      //   return FORBY_SLIDER_8;
      // case 'FORBY_SLIDER_9':
      //   return FORBY_SLIDER_9;
      // case 'FORBY_SLIDER_10':
      //   return FORBY_SLIDER_10;
      // case 'FORBY_SLIDER_11':
      //   return FORBY_SLIDER_11;
      // case 'FORBY_SLIDER_12':
      //   return FORBY_SLIDER_12;
      // case 'FORBY_SLIDER_13':
      //   return FORBY_SLIDER_13;
      // case 'FORBY_SLIDER_14':
      //   return FORBY_SLIDER_14;

      // case 'PUERTO_RICO_TITLE':
      //   return PUERTO_RICO_TITLE;
      // case 'PUERTO_RICO_STACK_1':
      //   return PUERTO_RICO_STACK_1;
      // case 'PUERTO_RICO_STACK_2':
      //   return PUERTO_RICO_STACK_2;
      // case 'PUERTO_RICO_STACK_3':
      //   return PUERTO_RICO_STACK_3;
      // case 'PUERTO_RICO_STACK_4':
      //   return PUERTO_RICO_STACK_4;
      // case 'PUERTO_RICO_STACK_5':
      //   return PUERTO_RICO_STACK_5;
      // case 'PUERTO_RICO_SLIDER_1':
      //   return PUERTO_RICO_SLIDER_1;
      // case 'PUERTO_RICO_SLIDER_2':
      //   return PUERTO_RICO_SLIDER_2;
      // case 'PUERTO_RICO_SLIDER_3':
      //   return PUERTO_RICO_SLIDER_3;
      // case 'PUERTO_RICO_SLIDER_4':
      //   return PUERTO_RICO_SLIDER_4;
      // case 'PUERTO_RICO_SLIDER_5':
      //   return PUERTO_RICO_SLIDER_5;
      // case 'PUERTO_RICO_SLIDER_6':
      //   return PUERTO_RICO_SLIDER_6;
      // case 'PUERTO_RICO_SLIDER_7':
      //   return PUERTO_RICO_SLIDER_7;
      // case 'PUERTO_RICO_SLIDER_8':
      //   return PUERTO_RICO_SLIDER_8;
      // case 'PUERTO_RICO_SLIDER_9':
      //   return PUERTO_RICO_SLIDER_9;
      // case 'PUERTO_RICO_SLIDER_10':
      //   return PUERTO_RICO_SLIDER_10;
      // case 'PUERTO_RICO_SLIDER_11':
      //   return PUERTO_RICO_SLIDER_11;
      // case 'PUERTO_RICO_SLIDER_12':
      //   return PUERTO_RICO_SLIDER_12;

      // case 'PUERTO_RICO_GUIDE_TITLE':
      //   return PUERTO_RICO_GUIDE_TITLE;
      // case 'PUERTO_RICO_GUIDE_STACK_1':
      //   return PUERTO_RICO_GUIDE_STACK_1;
      // case 'PUERTO_RICO_GUIDE_STACK_2':
      //   return PUERTO_RICO_GUIDE_STACK_2;
      // case 'PUERTO_RICO_GUIDE_STACK_3':
      //   return PUERTO_RICO_GUIDE_STACK_3;
      // case 'PUERTO_RICO_GUIDE_STACK_4':
      //   return PUERTO_RICO_GUIDE_STACK_4;
      // case 'PUERTO_RICO_GUIDE_STACK_5':
      //   return PUERTO_RICO_GUIDE_STACK_5;
      // case 'PUERTO_RICO_GUIDE_STACK_6':
      //   return PUERTO_RICO_GUIDE_STACK_6;
      // case 'PUERTO_RICO_GUIDE_STACK_7':
      //   return PUERTO_RICO_GUIDE_STACK_7;
      // case 'PUERTO_RICO_GUIDE_STACK_8':
      //   return PUERTO_RICO_GUIDE_STACK_8;
      // case 'PUERTO_RICO_GUIDE_SLIDER_1':
      //   return PUERTO_RICO_GUIDE_SLIDER_1;
      // case 'PUERTO_RICO_GUIDE_SLIDER_2':
      //   return PUERTO_RICO_GUIDE_SLIDER_2;
      // case 'PUERTO_RICO_GUIDE_SLIDER_3':
      //   return PUERTO_RICO_GUIDE_SLIDER_3;
      // case 'PUERTO_RICO_GUIDE_SLIDER_4':
      //   return PUERTO_RICO_GUIDE_SLIDER_4;
      // case 'PUERTO_RICO_GUIDE_SLIDER_5':
      //   return PUERTO_RICO_GUIDE_SLIDER_5;
      // case 'PUERTO_RICO_GUIDE_SLIDER_6':
      //   return PUERTO_RICO_GUIDE_SLIDER_6;
      // case 'PUERTO_RICO_GUIDE_SLIDER_7':
      //   return PUERTO_RICO_GUIDE_SLIDER_7;

    case 'WE_PATH_TITLE':
      return WE_PATH_TITLE;
    case 'WE_PATH_STACK_1':
      return WE_PATH_STACK_1;
    case 'WE_PATH_STACK_2':
      return WE_PATH_STACK_2;
    case 'WE_PATH_STACK_3':
      return WE_PATH_STACK_3;
    case 'WE_PATH_STACK_4':
      return WE_PATH_STACK_4;
    case 'WE_PATH_STACK_5':
      return WE_PATH_STACK_5;
    case 'WE_PATH_STACK_6':
      return WE_PATH_STACK_6;

      // case 'AC_NAUTICA_TITLE':
      //   return AC_NAUTICA_TITLE;
      // case 'AC_NAUTICA_STACK_1':
      //   return AC_NAUTICA_STACK_1;
      // case 'AC_NAUTICA_STACK_2':
      //   return AC_NAUTICA_STACK_2;
      // case 'AC_NAUTICA_STACK_3':
      //   return AC_NAUTICA_STACK_3;
      // case 'AC_NAUTICA_STACK_4':
      //   return AC_NAUTICA_STACK_4;
      // case 'AC_NAUTICA_STACK_5':
      //   return AC_NAUTICA_STACK_5;
      // case 'AC_NAUTICA_SLIDER_1':
      //   return AC_NAUTICA_SLIDER_1;
      // case 'AC_NAUTICA_SLIDER_2':
      //   return AC_NAUTICA_SLIDER_2;
      // case 'AC_NAUTICA_SLIDER_3':
      //   return AC_NAUTICA_SLIDER_3;
      // case 'AC_NAUTICA_SLIDER_4':
      //   return AC_NAUTICA_SLIDER_4;
      // case 'AC_NAUTICA_SLIDER_5':
      //   return AC_NAUTICA_SLIDER_5;
      // case 'AC_NAUTICA_SLIDER_6':
      //   return AC_NAUTICA_SLIDER_6;

      // case 'ALIBALANCE_TITLE':
      //   return ALIBALANCE_TITLE;
      // case 'ALIBALANCE_STACK_1':
      //   return ALIBALANCE_STACK_1;
      // case 'ALIBALANCE_STACK_2':
      //   return ALIBALANCE_STACK_2;
      // case 'ALIBALANCE_STACK_3':
      //   return ALIBALANCE_STACK_3;
      // case 'ALIBALANCE_STACK_4':
      //   return ALIBALANCE_STACK_4;
      // case 'ALIBALANCE_STACK_5':
      //   return ALIBALANCE_STACK_5;

      // case 'GREEN_CLINIC_TITLE':
      //   return GREEN_CLINIC_TITLE;
      // case 'GREEN_CLINIC_STACK_1':
      //   return GREEN_CLINIC_STACK_1;
      // case 'GREEN_CLINIC_STACK_2':
      //   return GREEN_CLINIC_STACK_2;
      // case 'GREEN_CLINIC_STACK_3':
      //   return GREEN_CLINIC_STACK_3;
      // case 'GREEN_CLINIC_STACK_4':
      //   return GREEN_CLINIC_STACK_4;
      // case 'GREEN_CLINIC_SLIDER_1':
      //   return GREEN_CLINIC_SLIDER_1;
      // case 'GREEN_CLINIC_SLIDER_2':
      //   return GREEN_CLINIC_SLIDER_2;
      // case 'GREEN_CLINIC_SLIDER_3':
      //   return GREEN_CLINIC_SLIDER_3;
      // case 'GREEN_CLINIC_SLIDER_4':
      //   return GREEN_CLINIC_SLIDER_4;
      // case 'GREEN_CLINIC_SLIDER_5':
      //   return GREEN_CLINIC_SLIDER_5;
      // case 'GREEN_CLINIC_SLIDER_6':
      //   return GREEN_CLINIC_SLIDER_6;
      // case 'GREEN_CLINIC_SLIDER_7':
      //   return GREEN_CLINIC_SLIDER_7;
      // case 'GREEN_CLINIC_SLIDER_8':
      //   return GREEN_CLINIC_SLIDER_8;
      // case 'GREEN_CLINIC_SLIDER_9':
      //   return GREEN_CLINIC_SLIDER_9;

      // case 'STTM_DESKTOP_TITLE':
      //   return STTM_DESKTOP_TITLE;
      // case 'STTM_DESKTOP_STACK_1':
      //   return STTM_DESKTOP_STACK_1;
      // case 'STTM_DESKTOP_STACK_2':
      //   return STTM_DESKTOP_STACK_2;
      // case 'STTM_DESKTOP_STACK_3':
      //   return STTM_DESKTOP_STACK_3;
      // case 'STTM_DESKTOP_STACK_4':
      //   return STTM_DESKTOP_STACK_4;
      // case 'STTM_DESKTOP_STACK_5':
      //   return STTM_DESKTOP_STACK_5;

      // case 'DEMOBUTLER_TITLE':
      //   return DEMOBUTLER_TITLE;
      // case 'DEMOBUTLER_STACK_1':
      //   return DEMOBUTLER_STACK_1;
      // case 'DEMOBUTLER_STACK_2':
      //   return DEMOBUTLER_STACK_2;
      // case 'DEMOBUTLER_STACK_3':
      //   return DEMOBUTLER_STACK_3;
      // case 'DEMOBUTLER_STACK_4':
      //   return DEMOBUTLER_STACK_4;
      // case 'DEMOBUTLER_STACK_5':
      //   return DEMOBUTLER_STACK_5;
      // case 'DEMOBUTLER_STACK_6':
      //   return DEMOBUTLER_STACK_6;
      // case 'DEMOBUTLER_STACK_7':
      //   return DEMOBUTLER_STACK_7;
      // case 'DEMOBUTLER_STACK_8':
      //   return DEMOBUTLER_STACK_8;
      // case 'DEMOBUTLER_STACK_9':
      //   return DEMOBUTLER_STACK_9;
      // case 'DEMOBUTLER_STACK_10':
      //   return DEMOBUTLER_STACK_10;
      // case 'DEMOBUTLER_STACK_11':
      //   return DEMOBUTLER_STACK_11;
      // case 'DEMOBUTLER_STACK_12':
      //   return DEMOBUTLER_STACK_12;
      // case 'DEMOBUTLER_STACK_13':
      //   return DEMOBUTLER_STACK_13;
      // case 'DEMOBUTLER_STACK_14':
      //   return DEMOBUTLER_STACK_14;
      // case 'DEMOBUTLER_STACK_15':
      //   return DEMOBUTLER_STACK_15;
      // case 'DEMOBUTLER_STACK_16':
      //   return DEMOBUTLER_STACK_16;

      // case 'MERIT_TITLE':
      //   return MERIT_TITLE;
      // case 'MERIT_STACK_1':
      //   return MERIT_STACK_1;
      // case 'MERIT_STACK_2':
      //   return MERIT_STACK_2;
      // case 'MERIT_STACK_3':
      //   return MERIT_STACK_3;
      // case 'MERIT_STACK_4':
      //   return MERIT_STACK_4;
      // case 'MERIT_STACK_5':
      //   return MERIT_STACK_5;
      // case 'MERIT_STACK_6':
      //   return MERIT_STACK_6;

    // case 'SELF_ID_TITLE':
    //   return SELF_ID_TITLE;
    // case 'SELF_ID_STACK_1':
    //   return SELF_ID_STACK_1;
    // case 'SELF_ID_STACK_2':
    //   return SELF_ID_STACK_2;
    // case 'SELF_ID_STACK_3':
    //   return SELF_ID_STACK_3;
    // case 'SELF_ID_STACK_4':
    //   return SELF_ID_STACK_4;
    // case 'SELF_ID_STACK_5':
    //   return SELF_ID_STACK_5;
    // case 'SELF_ID_STACK_6':
    //   return SELF_ID_STACK_6;
    // case 'SELF_ID_STACK_7':
    //   return SELF_ID_STACK_7;
    default:
      return FORBY_STACK_4;
  }
};
